import React from 'react';
import { useNavigate } from 'react-router-dom';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import Layout from './Layout';
import './PickListLanding.css';

const OPTIONS = [
  {
    key: 'import',
    name: 'Pick List Import',
    Icon: UploadFileOutlinedIcon,
    route: '/pick-list/import',
    description: 'Import pick lists from PDF',
  },
  {
    key: 'list',
    name: 'Pick List',
    Icon: AssignmentOutlinedIcon,
    route: '/pick-list/list',
    description: 'View and manage pick lists',
  },
];

const PickListLanding = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="pick-list-landing">
        <header className="pick-list-landing-header">
          <h1 className="home-menu-title">Pick List</h1>
          <p className="home-menu-intro pick-list-landing-intro">
            Main store: import PDF pick lists and manage orders for operators.
          </p>
        </header>
        <div className="pick-list-options-row" role="region" aria-label="Pick list actions">
          {OPTIONS.map((opt) => (
            <button
              key={opt.key}
              type="button"
              className="menu-card menu-card-dark menu-card-home pick-list-option-card"
              onClick={() => navigate(opt.route)}
            >
              <span className="menu-card-icon-wrap" aria-hidden>
                <opt.Icon className="menu-card-mui-icon" />
              </span>
              <span className="pick-list-card-text">
                <span className="menu-card-label">{opt.name}</span>
                <span className="pick-list-card-desc">{opt.description}</span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default PickListLanding;
